export default class Ingredient {
  name: string;
  description: string;
  img: string;
  image_alt: string;
  readMore: boolean;

  constructor(ingredient: any) {
    this.name = ingredient.name;
    this.description = ingredient.description;
    this.img = ingredient.img;
    this.readMore = ingredient.read_more;
    this.image_alt = ingredient.image_alt;
  }
}
